import React from "react";

import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

/**
 * Dumb renderer for the "Definition" and "Datengrundlage" sections.
 *
 * Note: "Datengrundlage" text is currently static across selections and is
 * therefore sourced from `nls.datengrundlageText`.
 */

const InfoSections = ({ visible, infoText, nls }) => {
  if (!visible) return null;

  return (
    <Stack spacing={2} sx={{ mt: 1 }}>
      <Stack>
        <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
          Definition:
        </Typography>
        <Typography variant="body2">{infoText}</Typography>
      </Stack>

      <Stack>
        <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
          Datengrundlage:
        </Typography>
        <Typography
          variant="body2"
          component="span"
          dangerouslySetInnerHTML={{ __html: nls?.datengrundlageText }}
        />
      </Stack>
    </Stack>
  );
};

export default InfoSections;
